import styled from 'styled-components'

const Style = {
	DurationInputWrapper: styled.div`
		display: flex;
		align-items: center;
		gap: 10px;
		margin-right: 20px;
	`,

	Label: styled.p`
		margin: 0;
		${({theme}) => theme.font.small_bold};
		color: ${({theme}) => theme.color.black};
	`,

	Input: styled.input`
		width: 80px;
		padding: 8px 12px;
		border: 1px solid ${({theme}) => theme.color.grey3};
		border-radius: 4px;
		${({theme}) => theme.font.extra_small};
		background-color: ${({theme}) => theme.color.white};
		transition: border-color 0.2s ease;

		&:focus {
			outline: none;
			border-color: ${({theme}) => theme.color.major};
		}

		&::placeholder {
			color: ${({theme}) => theme.color.grey3};
		}

		&:hover {
			border-color: ${({theme}) => theme.color.grey4};
		}
	`,

	Unit: styled.p`
		margin: 0;
		${({theme}) => theme.font.extra_small};
		color: ${({theme}) => theme.color.grey4};
	`,
}

export default Style
